import React from "react";
import { Button, ListItem, List, ListItemIcon, Typography, Box, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from 'prop-types';
import bin from '../assets/icons/primary-blue-bin.png';
import edit from '../assets/icons/secondary-light-black-app-window-edit.png';
import icBlueAdd from '../assets/icons/icBlueAdd.png';
import { MESSAGES_TYPE } from '../utils';
import { useTranslate } from 'react-admin';
import ListItemPopover from '../list-item-popover';

import InboxItem from './table-inbox-item';
import OutboxSentItem from './table-outbox-sent-item';
import OutboxDraftItem from './table-outbox-draft-item';
import OutboxScheduledItem from './table-outbox-scheduled-item';
import { usePopupState, bindToggle } from "material-ui-popup-state/hooks";


const useStyles = makeStyles(theme => ({
    root: {
        color: theme.palette.text.secondary,
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'row',
        paddingTop: theme.spacing(1.5),
        paddingBottom: theme.spacing(1.5),
        marginTop: theme.spacing(1),
        paddingLeft: 0,
    },
    unread: {
        backgroundColor: theme.palette.grey[200]
    },
    childItem: {
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    subjectText: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: 14,
        fontWeight: '500',
        color: '#237fc2',
        letterSpacing: 'normal'
    },
    anotherText: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: 11,
        fontWeight: '500',
        color: '#88898c',
        letterSpacing: 'normal',
        lineHeight: '13.2px'

    },
    iconContainer: {
        minWidth: 'unset',
        backgroundColor: '#e5f1f8',
        borderRadius:'12px',
        position: 'absolute',
        padding:8,
        top: 32,
        right: 16
    },
    icon: {
        width: 16,
        height: 16
    },
    iconPopover: {
        minWidth: 30
    },
    textTab: {
        fontSize: 13,
        color: '#4f5064',
        fontFamily: 'UniviaPro',
        fontWeight: 'normal',
        letterSpacing: '0.13px',
        lineHeight: '16.3px',
        fontStyle: 'normal',
        fontStretch: 'normal',
        padding: '5px'
    }
}));

function Index({ item, onCheck, onDelete, onEdit, onMarkRead, type, isUpdate, isDelete }) {
    const translate = useTranslate();
    const classes = useStyles();
    const popupState = usePopupState({ variant: 'popper', popupId: 'messageItemDialog' });
    const showEditButton = type === MESSAGES_TYPE.DRAFT || type === MESSAGES_TYPE.SCHEDULED;
    const onCheckboxClick = e => {
        // e.preventDefault();
        e.stopPropagation();
        onCheck(item.id);
    }

    const onDeleteItemClick = (event) => {
        popupState.close();
        onDelete([item.id]);
        event.stopPropagation()
    }

    const onEditItemClick = () => {
        popupState.close();
        onEdit(item.id);
    }

    return (
        <List style={{ paddingTop: 10, paddingBottom: 0 }} onClick={type === MESSAGES_TYPE.DRAFT || type === MESSAGES_TYPE.SCHEDULED?onEditItemClick:() => onMarkRead(item.id)}>
            {type === MESSAGES_TYPE.INBOX && <InboxItem item={item} classes={classes} onCheckboxClick={onCheckboxClick} isDelete={isDelete} />}
            {type === MESSAGES_TYPE.DRAFT && <OutboxDraftItem item={item} classes={classes} onCheckboxClick={onCheckboxClick}  isDelete={isDelete}  />}
            {type === MESSAGES_TYPE.SENT && <OutboxSentItem item={item} classes={classes} onCheckboxClick={onCheckboxClick} isDelete={isDelete} />}
            {type === MESSAGES_TYPE.SCHEDULED && <OutboxScheduledItem item={item} classes={classes} onCheckboxClick={onCheckboxClick}  isDelete={isDelete}  />}
            {
                isUpdate &&
                <IconButton className={classes.iconContainer} onClick={onDeleteItemClick}>
                    {/* <img alt='' src={icBlueAdd} className={classes.icon} /> */}
                    <img alt='' src={bin} style={{ width: "15px"}} />
                </IconButton>
            }
       
        </List >
    );
}

Index.propTypes = {
    item: PropTypes.object.isRequired,
    onCheck: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    onMarkRead: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
};

export default Index;
